import { useQuery } from "@tanstack/react-query";
import { freelancerPainelApi } from "@/services/freelancer-painel-api";
import type { FreelancerPainel, FreelancerResumoRapido } from "@/types/freelancer-painel";

/**
 * Resumo de WhatsApp e LinkedIn da página visível, numa chamada só (como a
 * disponibilidade). 403 de quem não tem a tela não é erro para mostrar: os
 * ícones só ficam sem o resumo.
 */
export function useFreelancerResumoRapido(freelancerIds: (string | null | undefined)[]) {
  const uniqueIds = Array.from(
    new Set(freelancerIds.filter((id): id is string => typeof id === "string" && id.length > 0)),
  ).sort();

  return useQuery({
    queryKey: ["freelancer-resumo-rapido", uniqueIds],
    enabled: uniqueIds.length > 0,
    staleTime: 5 * 60 * 1000,
    retry: false,
    queryFn: async (): Promise<Map<string, FreelancerResumoRapido>> => {
      const { itens } = await freelancerPainelApi.resumoRapido(uniqueIds);
      return new Map(Object.entries(itens));
    },
  });
}

export function useFreelancerPainel(freelancerId: string | null | undefined) {
  return useQuery({
    queryKey: ["freelancer-painel", freelancerId],
    enabled: !!freelancerId,
    staleTime: 5 * 60 * 1000,
    retry: false,
    queryFn: (): Promise<FreelancerPainel> => freelancerPainelApi.painel(freelancerId as string),
  });
}
